module.exports = __webpack_public_path__ + "img/_1.f5b70b17.png";